import {takeEvery} from 'redux-saga/effects';
import {SEND_CLIENT_LOG_SUCCESS, SEND_ORDER_FAILURE, SEND_ORDER_SUCCESS} from 'new-constants/api.constants';
import {removeLogs, setApplicationStartMessage, setInfoMessage} from 'managers/client-log.manager';
import {START} from 'new-constants/app-state.constants';
import {PWA_INSTALL_AVAILABLE, PWA_INSTALLED} from "../constants/pwa.constants";
import {
	CANCEL_PROFILE_STRIPE_CARD_REGISTRATION,
	CANCEL_STRIPE_CARD_REGISTRATION, CANCEL_VIPPS_PAYMENT_FRAME,
	DONE_CARD_STATUS, DONE_ZIP_EDIT_FROM_CART,
	DONE_DELIVERY_ADDRESS,
	DONE_LOGOUT_CONFIRMATION,
	DONE_ZIP_EDIT, DONE_DELIVERY_ADDRESS_FROM_CART
} from "../constants/popup.constants";
import {
	CHECK_PHONE_CODE_FAILURE,
	CHECK_PHONE_CODE_SUCCESS,
	ORDER_DATES_FAILURE,
	ORDER_DATES_SUCCESS,
	ORDER_TIME_SLOTS_FAILURE,
	ORDER_TIME_SLOTS_SUCCESS,
	REPEAT_ORDER_FAILURE,
	REPEAT_ORDER_SUCCESS,
	INIT_ADYEN_PAYMENT_SUCCESS,
	INIT_ADYEN_PAYMENT_FAILURE,
	CHECK_PAYMENT_STATUS_SUCCESS
} from "../constants/api.constants";
import {SET_ORDER_TYPE_INITIAL} from "../constants/ordering-mode.constants";
import {CAUTH_CLEAR_CUSTOMER_DATA, SET_CURRENT_RESTAURANT, SET_CURRENT_RESTAURANT_FROM_CART} from "../constants/app-state.constants";
import {select} from "@redux-saga/core/effects";
import {CHECKOUT} from "../constants/navigation.constants";
import {PaymentStatuses} from "new-constants/common.constants"
import {getAdyenReturnModeSelector, getAdyenReturnOrderIdSelector, getCurrentAppIdSelector} from "../selectors";
import {setJsError} from "../managers/client-log.manager";
import { MOBILE_PAY_REDIRECT } from '../constants/payment.constants';

function* removeSentLogs(action) {
	removeLogs(action.payload.idsToSend);
}

function* logStart() {
	setApplicationStartMessage();
}

function* logOrderSuccess(action) {
	if (!action.payload?.data?.order || !action.payload?.requestData?.order) {
		setInfoMessage('SendOrder: success=true, no data');
		return;
	}

	const {requestData, data} = action.payload;

	setInfoMessage(
		'SendOrder:' +
		'| success=true' +
		'| id=' +
		data.order?.orderId +
		'| token=' +
		requestData.order.token +
		'| restaurant=' +
		requestData.order.restaurantId +
		'| delivery=' +
		requestData.order.deliveryData?.isHomeDelivery +
		'| payment=' +
		requestData.order.paymentType +
		'| cardPin=' +
		(requestData.passwordLength > 0) +
		'| redirect=' +
		!!data.redirectUrl +
		'| stripeSecret=' +
		!!data.stripeClientSecret +
		'| adyenClientKey=' +
		!!data?.adyenClientKey +
		'| adyenPaymentMethodsResponse=' +
		!!data?.adyenPaymentMethodsResponse +		
		'| pickDate=' +
		requestData.order.pickupData?.pickupDate +
		'| pickTime=' +
		requestData.order.pickupData?.pickupTime +
		'| useCashPoints=' +
		requestData.order.useCashPoints
	);
}

function* logPWAInstallAvailable() {
	setInfoMessage('PWA install available');
}

function* logPWAInstalled() {
	setInfoMessage('PWA installed');
}

function* logOrderFailure(action) {
	if (!action.meta?.requestData?.order) {
		setInfoMessage('SendOrder: success=false, no data');
		return;
	}

	const {requestData, data} = action.meta;

	setInfoMessage(
		'SendOrder:' +
		'| success=false' +
		'| id=' +
		data?.order?.orderId +
		'| token=' +
		requestData.order.token +
		'| restaurant=' +
		requestData.order.restaurantId +
		'| delivery=' +
		requestData.order.deliveryData?.isHomeDelivery +
		'| payment=' +
		requestData.order.paymentType +
		'| cardPin=' +
		(requestData.passwordLength > 0) +
		'| redirect=' +
		!!data?.redirectUrl +
		'| stripeSecret=' +
		!!data?.stripeClientSecret +
		'| adyenClientKey=' +
		!!data?.adyenClientKey +
		'| adyenPaymentMethodsResponse=' +
		!!data?.adyenPaymentMethodsResponse +		
		'| pickDate=' +
		requestData.order.pickupData?.pickupDate +
		'| pickTime=' +
		requestData.order.pickupData?.pickupTime +
		'| useCashPoints=' +
		requestData.order.useCashPoints +
		'| messages=' +
		action.payload?.statusText
	);
}

function* logCardRemoval() {
	setInfoMessage('remove card');
}

function* logLogout() {
	setInfoMessage('logout');
}


function* clearCustomerData() {
	setInfoMessage('cauth clear customer data');
}

function* logPhoneCodeFailure() {
	setInfoMessage('phone code failure');
}

function* logOrderTypeSelect(action) {
	setInfoMessage(`set order type ${action?.orderType}`);
}

function* logRestaurantSelect(action) {
	setInfoMessage(`open restaurant ${action?.restaurantId}`)
}

function* logRestaurantSelectFromCart(action) {
	setInfoMessage(`open restaurant from cart ${action?.restaurantId}`)
}

function* logPhoneConfirmation(action) {
	const {customer} = yield select();
	setInfoMessage(`${customer?.currentCustomer?.customerId} => ${action?.payload?.data?.phone}`)
}

function* logDoneDeliveryAddress() {
	setInfoMessage('Done delivery address');
}

function* logDoneDeliveryAddressFromCart() {
	setInfoMessage('Done delivery address from cart');
}

function* logDoneZipEdit() {
	setInfoMessage('Done zip edit');
}

function* logDoneZipEditFromCart() {
	setInfoMessage('Done zip edit from cart');
}

function* logCheckout() {
	setInfoMessage('Checkout');
}

function* logStripeCardRegistrationCancel() {
	setInfoMessage('Cancel stripe card registration');
}

function* logVippsPaymentFrameCancel() {
	setInfoMessage('Cancel vipps payment frame');
}

function* logFailedRepeatOrder() {
	setInfoMessage('Repeat order failed');
}

function* logSuccessfulRepeatOrder(action) {
	setInfoMessage(`Repeat order success ${action?.data?.order?.orderId}`);
}

const debugAppIds = ['mundret', 'dinner', 'dinnergruppen'];

function* logDebugTimeSlotsSuccess(action) {
	const state = yield select();

	if (!action.payload?.timeSlots?.length) {
		const message = `+-+ Empty timeslots 
				restaurantId=${action.payload.debugRequestParams?.restaurantId},
				orderAmount=${action.payload.debugRequestParams?.orderAmount},
				pickupDate=${action.payload.debugRequestParams?.pickupDate},
				zipCode=${action.payload.debugRequestParams?.zipCode}
				message=${JSON.stringify(action.payload.messages)}
			`;

		setInfoMessage(message);

		if(debugAppIds.includes(getCurrentAppIdSelector(state))){
			setJsError(message);
		}
	}
}

function* logDebugTimeSlotsFailure(action) {
	const state = yield select();
	const message = `+-+ Time slots loading failure: ${action.payload?.message}`;

	setInfoMessage(message);

	if (debugAppIds.includes(getCurrentAppIdSelector(state))) {
		setJsError(message);
	}
}

function* logDebugDateSuccess(action) {
	const state = yield select();

	if (!action.payload?.timeSlots?.length || !action.payload?.dates?.length) {
		const message = `+-+ Empty date
			restaurantId=${action.payload.debugRequestParams?.restaurantId},
			orderAmount=${action.payload.debugRequestParams?.orderAmount},
			pickupDate=${action.payload.debugRequestParams?.pickupDate},
			zipCode=${action.payload.debugRequestParams?.zipCode}
			message=${JSON.stringify(action.payload.messages)}
		`;

		setInfoMessage(message);

		if(debugAppIds.includes(getCurrentAppIdSelector(state))){
			setJsError(message);
		}
	}
}

function* logDebugDateFailure(action) {
	const state = yield select();

	const message = `Date loading failure: ${action.payload?.message}`;

	setInfoMessage(message);

	if (debugAppIds.includes(getCurrentAppIdSelector(state))) {
		setJsError(message);
	}
}

function* logInitAdyenPaymentSuccess() {
	setInfoMessage('InitAdyenPaymentSuccess')
}

function* logInitAdyenPaymentFailure(action) {
	setInfoMessage(`InitAdyenPaymentFailure:${action.payload?.message}`)
}

function* logAdyenModeStart(action) {
	setInfoMessage(`
		Starting in Adyen mode: 
		orderId: ${action.returnFromAdyen.orderId},
		restaurantId: ${action.returnFromAdyen.restaurantId},
		orderType: ${action.returnFromAdyen.orderType},
		redirectResult: ${!!action.returnFromAdyen.redirectResult},
	`)
}

function* logOpeningAdyenOrder(action) {
	setInfoMessage(`Opening Adyen order: ${action.payload.orderId}`)
}

function* logAdyenOrderCancelledPopup(action) {
	setInfoMessage(`Showing Adyen Cancelled Popup: ${action.payload.orderId}`)
}

function* logMobilePayRedirect() {
	setInfoMessage('Redirected to MobilePay');
}

function* logAdyenReturnMode(action) {
	const state = yield select();
	setInfoMessage(`
		Adyen Return mode: ${action.adyenReturnMode},
		Adyen Url Order Id: ${action.adyenUrlOrderId},
		Adyen State Order Id: ${getAdyenReturnOrderIdSelector(state)}
	`);
}
 			
export const clientLogSaga = function* clientLogSaga() {
	yield takeEvery(SEND_CLIENT_LOG_SUCCESS, removeSentLogs);
	yield takeEvery(START, logStart);
	yield takeEvery(SEND_ORDER_SUCCESS, logOrderSuccess);
	yield takeEvery(SEND_ORDER_FAILURE, logOrderFailure);
	yield takeEvery(PWA_INSTALL_AVAILABLE, logPWAInstallAvailable);
	yield takeEvery(PWA_INSTALLED, logPWAInstalled);
	yield takeEvery(DONE_CARD_STATUS, logCardRemoval);
	yield takeEvery(DONE_LOGOUT_CONFIRMATION, logLogout);
	yield takeEvery(CAUTH_CLEAR_CUSTOMER_DATA, clearCustomerData);
	yield takeEvery(CHECK_PHONE_CODE_FAILURE, logPhoneCodeFailure);
	yield takeEvery(SET_ORDER_TYPE_INITIAL, logOrderTypeSelect);
	yield takeEvery(SET_CURRENT_RESTAURANT, logRestaurantSelect);
	yield takeEvery(SET_CURRENT_RESTAURANT_FROM_CART, logRestaurantSelectFromCart);
	yield takeEvery(CHECK_PHONE_CODE_SUCCESS, logPhoneConfirmation);
	yield takeEvery(DONE_DELIVERY_ADDRESS, logDoneDeliveryAddress);
	yield takeEvery(DONE_DELIVERY_ADDRESS_FROM_CART, logDoneDeliveryAddressFromCart);
	yield takeEvery(DONE_ZIP_EDIT, logDoneZipEdit);
	yield takeEvery(DONE_ZIP_EDIT_FROM_CART, logDoneZipEditFromCart);
	yield takeEvery(CHECKOUT, logCheckout);
	yield takeEvery([CANCEL_STRIPE_CARD_REGISTRATION, CANCEL_PROFILE_STRIPE_CARD_REGISTRATION], logStripeCardRegistrationCancel);
	yield takeEvery([CANCEL_VIPPS_PAYMENT_FRAME], logVippsPaymentFrameCancel);
	yield takeEvery([REPEAT_ORDER_FAILURE], logFailedRepeatOrder);
	yield takeEvery([REPEAT_ORDER_SUCCESS], logSuccessfulRepeatOrder);
	yield takeEvery([ORDER_TIME_SLOTS_SUCCESS], logDebugTimeSlotsSuccess);
	yield takeEvery([ORDER_TIME_SLOTS_FAILURE], logDebugTimeSlotsFailure);
	yield takeEvery([ORDER_DATES_SUCCESS], logDebugDateSuccess);
	yield takeEvery([ORDER_DATES_FAILURE], logDebugDateFailure);
	yield takeEvery([INIT_ADYEN_PAYMENT_SUCCESS], logInitAdyenPaymentSuccess);
	yield takeEvery([INIT_ADYEN_PAYMENT_FAILURE], logInitAdyenPaymentFailure);
	yield takeEvery(action => action.type === START && action.returnFromAdyen, logAdyenModeStart);
	yield takeEvery(
		action => action.type === CHECK_PAYMENT_STATUS_SUCCESS && action.payload.isAdyenOrder && action.payload.data.status === PaymentStatuses.complete,
		logOpeningAdyenOrder
	);
	yield takeEvery(
		action => action.type === CHECK_PAYMENT_STATUS_SUCCESS && action.payload.isAdyenOrder && action.payload.data.status === PaymentStatuses.cancelled,
		logAdyenOrderCancelledPopup
	);
	yield takeEvery([MOBILE_PAY_REDIRECT], logMobilePayRedirect);
	yield takeEvery((action) => action.type === START && !!action.adyenReturnMode, logAdyenReturnMode);

};
